import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpService } from '@sondermind/http';
import { IAPIFetchRequestOptions } from '@sondermind/utilities/models-http';
import { Logger } from '@sondermind/datadog-logging';
import { ConfigurationService } from '@sondermind/configuration';

export enum UpdateEvent {
  OPENED = 'opened',
  COMPLETED = 'completed'
}

@Injectable({
  providedIn: 'root',
})
export class AssessmentProgressHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService,
    private logger: Logger,
  ) {}

  svcBase = this.configurationService.env.svcBase;
  urlBase: string | undefined = undefined;

  setPatchUrlRoute(route: string): void {
    this.urlBase = `${this.svcBase}${route}`;
  }

  patchAssessmentProgressState(
    appMessageDeliveryId: number | string,
    status: UpdateEvent,
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<undefined | null> {
    if (!this.urlBase) {
      this.logger.warn('No base url set to patch assessment progress updates');
      return of(undefined);
    }

    const patchUrl = `${this.urlBase}/${appMessageDeliveryId}`;

    return this.http
      .patch(patchUrl, { event: status })
      .pipe(
        map(() => undefined),
        this.http.handleHttpError(opts.error)
      );
  }
}
